import { render, staticRenderFns } from "./TaskEditTabInformation.vue?vue&type=template&id=63a7c12d&"
import script from "./TaskEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./TaskEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./TaskEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports